import { createSelector } from 'reselect';
import get from 'lodash/get';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { supportedMetricsSelector } from '@store/common/selectors';
import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';
import { AD_PLAYS, isEiModule, isAppModule } from '@utils/constants';
import { getECODimensionList } from '@src/utils/dimension/getDimensionsForPreset';
import { SCOPE } from './types';

const selector = (state) => state[SCOPE];

export default selector;

// Can be removed once ad dimensions are added to all dashboards
export const dimensionsListSelector = createSelector(selector, (store) => {
  return store.response.filter((dimension) => {
    if (isEiModule) {
      return dimension.type !== DIMENSION_TYPES_CONSTANTS.ai;
    }

    return true;
  });
});

export const allDimensionsListSelector: any = createSelector(
  selector,
  supportedMetricsSelector,
  dimensionsListSelector,
  activeDashboardSelector,
  (store, metricList, eiDimensions, activeDashboard) => {
    const dimensions = store.response;

    if (isEiModule && !(AD_PLAYS in metricList)) {
      return eiDimensions;
    }

    if (isAppModule) {
      return getECODimensionList(activeDashboard, dimensions);
    }

    return dimensions;
  },
);

export const dimensionsListSelectorKeyValue: any = createSelector(
  selector,
  allDimensionsListSelector,
  (store, dimensionList) => {
    const dimensionObject = {};
    dimensionList.forEach((dimension) => {
      dimensionObject[dimension.groupBy] = dimension.name;
    });

    return dimensionObject;
  },
);

export const dimensionByTypesSelector: any = createSelector(
  selector,
  allDimensionsListSelector,
  (store, dimensionList) => {
    const dimensionObject = {};
    dimensionList.forEach((dimension) => {
      // for NA logic type is added for all products
      if (dimension.type) {
        dimensionObject[dimension.groupBy] = dimension.type;
      }
    });
    return dimensionObject;
  },
);

export const isFetchingSelector = createSelector(selector, (dimensionListStore) => ({
  isFetching: get(dimensionListStore, 'isFetching', false),
}));
